import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class LeavesPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{LeavesPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <span>leaves goes here ...</span>
                    </div>
                </div>
            </div>
        );
    }
}

LeavesPage.meta = {
    label: <FormattedMessage id={'leaves'} defaultMessage={'Leaves'} />,
    icon: 'pool',
    action: () => history.push('/leaves'),
    locations: ['/leaves']
};

export default LeavesPage;



// WEBPACK FOOTER //
// ./src/pages/leaves/index.jsx